export function getContactFormEndpoint() {
  if (typeof window === 'undefined') {
    return '';
  }

  return "https://s1ooghi6cj.execute-api.us-east-2.amazonaws.com/send-email";
}

export async function sendContactForm(payload) {
  const endpoint = getContactFormEndpoint();

  if (!endpoint) {
    throw new Error('Configura window.__ALGORIZA_CONFIG__.api.algoriza.com.mx/send-email con tu endpoint de Lambda o API Gateway.');
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = 'No se pudo enviar el correo';

    try {
      const data = await response.json();
      if (data?.message) {
        message = data.message;
      }
    } catch {
      const text = await response.text();
      if (text) {
        message = text;
      }
    }

    throw new Error(message);
  }

  return response.json().catch(() => ({}));
}